export const BILLABLE_PRICE_ERROR = 'Enter a numeric billable amount (for example, 1.75), or remove the billing transaction. '
  + 'Put units such as /mile in the description. For inherited amounts, update the task type or scheduled task.';

export const isBillablePriceInput = (value) => /^-?\d*(\.\d*)?$/.test(value);

// Keep the existing currency formats accepted by the API when validating inherited values.
const amount = '(?:(?:[0-9]+|[0-9]{1,3}(?:,[0-9]{3})+)(?:\\.[0-9]*)?|\\.[0-9]+)(?:[eE][+-]?[0-9]+)?';
const completePrice = new RegExp(`^(?:(?:[+-]?\\$?|\\$[+-]?)${amount}|\\(\\$?${amount}\\))$`);

export const isValidBillablePrice = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === 'number') return Number.isFinite(value);
  if (typeof value !== 'string') return false;
  const text = value.trim();
  if (text === '') return true;
  if (!completePrice.test(text)) return false;
  const numeric = text.replace(/[$,]/g, '').replace(/^\((.*)\)$/, '-$1');
  return Number.isFinite(Number(numeric));
};

export const getBillablePriceError = (eventData, fieldName = 'Billable Price') => {
  const entry = eventData?.[fieldName];
  let value = entry;
  if (entry && typeof entry === 'object' && Object.prototype.hasOwnProperty.call(entry, 'value')) value = entry.value;
  if (isValidBillablePrice(value)) return '';
  return BILLABLE_PRICE_ERROR;
};

export const getScheduleBillablePriceError = (request) => {
  if (!request) return '';
  const data = [request.eventDataDefaultValues, request.eventData,
    ...(request.workflows || []).map((workflow) => workflow.eventDataDefaultValues)];
  const invalid = data.some((values) => getBillablePriceError(values));
  if (invalid) return BILLABLE_PRICE_ERROR;
  return getScheduleBillablePriceError(request.exceptionSchedule);
};
